export default __webpack_public_path__ + "static/media/3761.46876117.png";